// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___3sKqT","like":"styles__like___17egL","selected":"styles__selected___3ED5o","icon":"styles__icon___1lRJB"};